<template>
  <div>
 <!--    <div class="main-banner">
      <a href="https://missionmag.org"  style="width:400px;height:124px;">
       <div class="head-row">
        </div>
      </a>
    </div> -->
    <div style="background-color: #ffffff;    min-height: 10vh !important;    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1);    z-index: 1000;   ">
      <nav class="navbar navbar-light bg-light"
      :class="{'navbar-dark bg-dark' : openCol}"
      >
      <div class="burger-menu" @click="toggleMenu()"  data-toggle="collapse" data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
        <span :class="{ active: isOpen }"></span>
        <span :class="{ active: isOpen }"></span>
        <span :class="{ active: isOpen }"></span>
      </div>
<!--         <div>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon" :class="{'navbar-toggler-icon2': openCol}" ></span>
          </button>
        </div> -->
        <div>
          <a class="navbar-brand" href="https://www.missionmag.org/">
            <img v-if="!openCol" src="../img/mission-logo.png" alt="Mission"  class="d-inline-block align-top">          
            <img v-else style="height:64.2px;padding: 5px;" src="../img/Mission_LOGO.png" alt="Mission" class="d-inline-block align-top-dark">          
          </a>
        </div>
        <div v-if="!openCol" class="navicons">
          <!-- <a target="_blank" class="navico "  style="padding-right: 40px ;cursor: pointer;" href="https://www.missioncreativ.com/"><img src="../img/MISSION_CREATIVE_LOGOBLACK.png" alt="" width="200"></a> -->
          <a target="_blank" class="s-hidden  navico icon-facebook" style="padding-left: 15px ;cursor: pointer;" href="https://www.facebook.com/Mission-Magazine-442919522536674/?fref=ts"></a>
          <a target="_blank" class="s-hidden  navico icon-x" style="padding-left: 50px ;cursor: pointer;" href="https://x.com/mission_mag"></a>
          <a target="_blank"	 class="s-hidden  navico icon-instagram" style="padding-left: 50px;cursor: pointer;" href="https://www.instagram.com/missionmagazine/?hl=en"></a>
    
        </div>
        <div v-else></div>
      </nav> 
      <div class="collapse bg-dark" id="navbarToggleExternalContent">
        <div class="align-navbar">
          <div class="bg-dark p-3">
            <ul>
              <li><a class="text-white" href="https://www.missionmag.org/category/music/">MUSIC</a></li>
              <li><a class="text-white" href="https://www.missionmag.org/category/film/">FILM</a></li>
              <li><a class="text-white" href="https://www.missionmag.org/category/fashion-beauty/">FASHION & BEAUTY</a></li>
              <li><a class="text-white" href="https://www.missionmag.org/category/culture-club/">CULTURE CLUB</a></li>
              <li><a class="text-white" href="https://www.missionmag.org/category/sustainability/">SUSTAINABILITY</a></li>
              <li><a class="text-white" href="https://www.missionmag.org/category/philanthropy/">PHILANTHROPY</a></li>
              <li><a class="text-white" href="https://www.missionmag.org/category/news/">NEWS</a></li>
              <li><a class="text-white" href="https://www.missionmag.org/category/art/">ART</a></li>
            </ul>            
          </div>
          <div class="bg-dark p-3">
             <ul>
              <li><a class="text-white" href="https://missionmagazinesubscriptions.org/">DIGITAL MAGAZINE</a></li>
              <li><a class="text-white" href="https://missionmag.org/stockists/">PRINT MAGAZINE</a></li>
              <li><a class="text-white" href="https://missionmag.org/polaroids/">#MYMISSIONIS</a></li>
              <li><a class="text-white" href="https://missionmag.org/category/podcast/">PODCAST</a></li>
              <li><a class="text-white" href="https://www.missionmag.org/youth-series/">YOUTH SERIES</a></li>
              <li><a class="text-white" href="https://www.missionmag.org/category/sport/">SPORT</a></li>
            </ul>            
          </div>
          <div class="bg-dark p-2">
            <ul>
              <li><a class="text-white" href="https://missionmag.org/about/">ABOUT</a></li>
              <li><a class="text-white" href="https://missionmag.org/category/press/">PRESS</a></li>
              <li><a class="text-white" href="https://missionmag.org/subscribe/">SUBSCRIBE</a></li>
              <li><a class="text-white" href="https://missionmag.org/contact/">CONTACT</a></li>
              <li><a class="text-white" href="https://www.missionmag.org/privacy-policy/">PRIVACY POLICY</a></li>
              <li><a class="text-white" href="https://www.missionmag.org/donate-2/">DONATE</a></li>             
              <li>
                <a target="_blank" class="text-white" style="padding-right: 15px; cursor: pointer;" href="https://www.facebook.com/Mission-Magazine-442919522536674/?fref=ts"><i class="icon-facebook"></i></a>
                <a target="_blank" class="text-white" style="padding-left: 20px; padding-right: 20px; cursor: pointer;" href="https://x.com/mission_mag"><i class="icon-x"></i></a>
                <a target="_blank" class="text-white" style=" padding-left: 20px; cursor: pointer;" href="https://www.instagram.com/missionmagazine/?hl=en"><i class="icon-instagram"></i></a>
              </li>
            </ul>          
          </div>
          <div class="bg-dark p-4">
            <img src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/covers%2Fissue12.png?alt=media&token=94445076-5af2-438f-b9b2-060c2b233eb6" style="width:80%" alt="cover issue">
						<div class=" justify-content-between custom-footer" style="margin:0px;"  >
							<p class="text-footer">ISSUE TWELVE</p>
							<button type="button" class="btn btn-custom"  @click="close()" >BUY NOW</button>
						</div>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>
<script>
import 'bootstrap';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookF,faTwitter,faInstagram } from '@fortawesome/free-brands-svg-icons'
export default {
  name: "navBar",
   components: {
      FontAwesomeIcon,
    },
    data() {
      return {
        face: faFacebookF,
        twit: faTwitter,
        insta: faInstagram,
        openCol: false,
        isOpen: false

      }
    },
    methods: {
			toHome() {
			this.$router.push("/the-magazine");
		},
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    open(){
      this.openCol = !this.openCol
    },
		close(){
			
				$('.collapse').collapse('hide')
				this.openCol = !this.openCol
			
		},
    onOver() {
      this.$refs.dropdown1.visible = true;
    },
    onLeave() {
      this.$refs.dropdown1.visible = false;
    },
    over() {
      this.$refs.dropdown2.visible = true;
    },
    leave() {
      this.$refs.dropdown2.visible = false;
    },

  }

}
</script>

<style lang="scss">
.align-top{
  margin-right:0;
  margin-left: 10rem;
  height:64.2px;
  padding: 5px;
  @media (max-width: 769px) {    
      height: 45px;
      margin: auto;
      padding:0px
  }
}
.navbar {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    @media (max-width: 430px) {    
      justify-content: normal;
  }
}


.head-row {
  background-image: url('https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/banner%2Fmissionmag_header.png?alt=media&token=f46dec06-0886-41c7-93e7-588d4f348eb7');
  background-repeat: no-repeat;
  background-size: contain;
  background-position:top center;
  min-height: 498px;
  @media (max-width: 769px) {
    background-size: cover;
    min-height: 107px;
  }
}
.navbar-light .navbar-toggler {
	padding: 0.25rem 0.5rem;
  color: rgba(0, 0, 0, 0.5);
  border-color: transparent;
  @media (max-width: 430px) {
    padding: 0.25rem 5.5rem 0.25rem 0;
  }
}
.align-navbar{
    position: absolute;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    padding: 4.5rem 10.5rem 0 10.5rem ;
   // padding: 4.5rem 0.5rem 0 0.5rem ;
    z-index: 100;
    background-color: black;
    width: 100%;
    min-height: 1077px;
}
ul {
  list-style-type: none;
}
.bg-light{
  font-family: 'lemon_milkregular';
  background-color: #fff !important;
}
.bg-dark{
  font-family: 'lemon_milkregular';
  background-color: #000 !important;
}
.navbar-toggler-icon2 {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 100% / 100% 100% no-repeat;
  right: 7%;
  z-index: 1000;
  position: absolute;
}
.navbar-dark .navbar-toggler-icon {
  background-image: url("../img/x-lg.svg");
}

nav {
  font-family: 'lemon_milkregular';
}
.text-white{
  color: #fff !important;
  font-size: 1.2rem;
  text-align: left;
  line-height:2.5rem;
  &:hover,
  &:active{
    color: #fff !important;

  } 
}
.navico{ 
    color: #999999!important;    
    cursor: pointer;
		&:hover{
			color: #999999!important;

		}
}
.align-top-dark{
	height: 100px;
	padding-left:20px
}
.navicons{
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 769px) {
    display: none;

  }
}
.custom-footer {
	display: flex;
	width: 80%;
	margin: 0 auto;
	align-items: baseline;
}
.btn-custom {
	display: flex;
	padding: 10px 40px;
	margin-top: 20px;
	color: #FFFFFF98;
	border: 1px solid #FFFFFF98;
	border-radius: 0px;

	&:hover {
		border: 1px solid #565d62;
		color: #565d62;
	}
}
@media (max-width: 767px) {
	.s-hidden {
		display: none;
	}
}
.burger-menu {
  width: 35px;
  height: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;

  span {
    display: block;
    height: 1px;
    width: 100%;
    background-color: #333;
    border-radius: 2px;
    transition: 0.4s ease-in-out;

    // Anima el primer span (línea superior) cuando está activo
    &:nth-child(1) {
      &.active {
        transform: rotate(45deg) translate(8px, 5px);
      }
    }

    // Anima el segundo span (línea del medio) cuando está activo
    &:nth-child(2) {
      &.active {
        opacity: 0;
      }
    }

    // Anima el tercer span (línea inferior) cuando está activo
    &:nth-child(3) {
      &.active {
        transform: rotate(-45deg) translate(8px, -5px);
      }
    }
  }
}


</style>